import React from 'react';
import { Outlet } from 'react-router-dom';
import AuditNavbar from './AuditNavbar';
import AuditFooter from './AuditFooter';

const AuditLayout = () => {
    return (
        <div className="flex flex-col min-h-screen bg-gray-50 font-sans">
            <AuditNavbar />
            <main className="flex-grow p-8">
                <Outlet />
            </main>
            <AuditFooter />
        </div>
    );
};

export default AuditLayout;
